/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientRiskMatrixStateResponseDto } from '../../models/client-risk-matrix-state-response-dto';

export interface GetState$Params {
  kycProcessId: string;
  answeredBy?: 'CLIENT' | 'COMPLIANCE';
}

export function getState(http: HttpClient, rootUrl: string, params: GetState$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientRiskMatrixStateResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getState.PATH, 'get');
  if (params) {
    rb.query('kycProcessId', params.kycProcessId, {});
    rb.query('answeredBy', params.answeredBy, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientRiskMatrixStateResponseDto>;
    })
  );
}

getState.PATH = '/kyc/client-risk-matrix/state';
